import { useMutation } from '@apollo/client';

import { DELETE_PLACE } from '../graphql/mutation/deletePlaceMutation.graphql';
import { PLACES } from '../graphql/query/placesQuery.graphql';

export const useDeletePlaceMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(DELETE_PLACE, { onCompleted });

  const deletePlace = (placeId: string) => {
    mutate({
      variables: {
        placeId,
      },
      refetchQueries: [PLACES],
    });
  };

  return { deletePlace };
};
